module.exports = __webpack_public_path__ + "img/Girl_020015.dfd46f6b.png";